import React, { Component } from 'react';
import _PrimaryButton from './_primary-button';

const styles = {
  container: {
    height: 60,
    width: 240,
    borderRadius: 30
  }
};

export default class PrimaryButton extends Component {
  render() {
    const { style, ...props } = this.props;
    return (
        <_PrimaryButton style={{ ...styles.container, ...style }}
                        {...props} />
    );
  }
};





// WEBPACK FOOTER //
// ./src/base-components/primary-button.js